const msg = {
    'ja': {
        'name': '名前',
        'kana name': 'カナ',
        'get data': 'データ取得',
        'login': 'ログイン',
        'logout': 'ログアウト',
        'date': '日付',
        'shift': 'シフト',
        'factory name': '工場名',
        'factory ID': '工場ID',
        'line name': 'ライン名',
        'line ID': 'ラインID',
        'facility name': '設備名',
        'facility ID': '設備ID',
        'facility No. (MacAddress, , , etc)': '設備識別子(MACアドレス等)',
        'line_flag': 'ラインの代表',
        'facility status': '設備状態',
        'production_amount_at': '実績取得先',
        'NP/ND tag': '良品数/不良品数タグ',
        'NS tag': 'ショット数タグ',
        'process ID': '手順ID',
        'process_name': '手順名',
        'worker ID': '担当ID',
        'search Worker Name': '担当名前検索',
        'search Worker ID': '担当ID検索',
        'entry or search': '登録or検索',
        'production plan number': '生産計画番号',
        'start camera': 'カメラ起動',
        'scan barcode': 'バーコードスキャン',
        'm_work_process': '作業(手順名)マスタ',
        'm_work_content': '作業(内容)マスタ',
        'i_work_to_facility': '作業と設備 関連付け',
        'facility_and_modbus': '作業と設備へのModbusアドレス設定',
        'm_product': '製品マスタ',
        'm_report_content': '報告内容マスタ',
        'm_call_content': '呼び出し内容マスタ',
        'm_worker': '作業者マスタ',
        'm_work_order': '作業マスタ',
        'm_factory': '工場マスタ',
        'm_line': 'ラインマスタ',
        'm_facility': '設備マスタ',
        'm_alarm': 'アラームマスタ',
        'alarm_code': 'アラームコード',
        'alarm_category': 'アラーム分類',
        'alarm name': 'アラーム名',
        'm_alarm_bit': 'アラームビットマスタ',
        'tag_name': 'タグ名',
        'i_report_to_alarm': '報告とアラーム 関連付け',
        'm_production_plan': '生産計画マスタ',
        'dead_line': '納期',
        'entry': '登録',
        'beginning of production': '製造開始',
        'end of manufacture': '製造終了',
        'work ID': '作業ID',
        'work content ID': '作業内容ID',
        'report ID': '報告ID',
        'call ID': '呼び出しID',
        'm_status_bit': 'ステータスビットマスタ',
        'combination': 'bit組み合わせ',
        'mask': 'ビットマスク',
        'code': '対応コード',
        'm_facility_status_group': 'ステータスグループマスタ',
        'status_group_id': 'ステータスグループID',
        'm_facility_status': 'ステータスコードマスタ',
        'm_facility_status_no_group': '所属無し',
        'status_id': 'ステータスID',
        'status_code': 'ステータスコード',
        'm_cycle_time': 'サイクルタイムマスタ',
        'cycle_time': '標準サイクルタイム(秒/個)',
        'pitch': '標準ピッチ(個/分)',
        'm_alarm_mixed_tag': 'アラーム複合タグ',
        'log_value': 'ログ値',
        'alarm_type': 'アラーム種別',
        't_scheduled_stop': '計画停止マスタ',
        'stop_start': '計画停止開始時刻',
        'stop_end': '計画停止終了時刻',
        'stop_interval': '計画停止間隔(日)',
        'm_maintenance': 'メンテナンスマスタ',
        'maintenance ID': 'メンテナンスID',
        'contents': 'メンテナンス内容',
        'interval': '実施間隔',
        'interval unit': '実施間隔（単位）',
        'interval value': '実施間隔（値）',
        'unit month': '月（30日間）',
        'unit week': '週',
        'unit day': '日',
        'interval unit month': 'か月',
        'interval unit week': '週間',
        'interval unit day': '日間',
        'scheduled_start_date': '開始予定日',
        'count_limit': '実施回数制限',
        'm_iot_alarm': 'IoT警告マスタ',
        'iot alarm id': 'IoT警告ID',
        'iot alarm name': '警告名称',
        'iot alarm message': '警告メッセージ',
        'monitoring cycle': '監視周期',
        'notify id': '通知方法ID',
        'iot alarm description': '説明文',
        'condition': '条件',
        'time range': '日時範囲',
        'progresss input tools': '進捗入力ツール',
        'select page': '設備選択、担当選択',
        'facility select page': '設備選択',
        'worker select page': '担当選択',
        'worker name': '担当者名',
        'description': '備考',
        'warning': '警告',
        'alert': '異常',
        'factory': '工場',
        'line': 'ライン',
        'process': '工程',
        'read page': 'バーコード読み取り',
        'production plan list': '生産計画一覧',
        '(production plan and progress) history list': '履歴一覧',
        'link to list': 'ロット一覧へ',
        'worker': '担当',
        'register page': '進捗入力画面',
        'facility': '設備',
        'production quantity': '良品数',
        'defective quantity': '不良品数',
        'report list': '報告事項一覧',
        'report input': '報告入力',
        'report type': '報告種別',
        'report content': '報告内容',
        'call list': '呼び出し事項一覧',
        'call input': '呼び出し入力',
        'call content': '呼び出し内容',
        'start time': '発生日時',
        'end time': '終了時間',
        'status': 'ステータス',
        'time': '時刻',
        'confirm': '確定',
        'cancel': 'キャンセル',
        'cancellation': '取り消し',
        'select': '選択',
        'change': '変更',
        'delete progress': '進捗削除',
        'delete progress warning': '※現在開いている進捗を削除します(終了打刻した進捗は削除できません)。',
        'operation status': '稼働状況',
        'actual quantity input': '実績入力',
        'actual quantity modify': '実績修正',
        'actual quantity update': '実績更新',
        't_progress_history_worker_list': '担当者リスト',
        't_progress_history_worker_list_branch': 'ポジション',
        'search Facility ID': '設備検索',
        'search Call ID': '呼び出し検索',
        'search Report ID': '報告検索',
        'update status time': 'ステータス時刻変更',
        'link to history': '履歴表示',
        'list page': '進捗一覧画面',
        'link to read': 'バーコード読み取りへ',
        'link to plan': '生産計画一覧へ',
        'production status': '生産ステータス',
        'in prepared': '未開始',
        'in ended': '終了済み',
        'in production': '生産中',
        'lot no / production plan number': 'ロット/生産計画番号',
        'serial no': '品番',
        'serial_no': '品番(ID)',
        'product_name': '品名',
        'start': '開始',
        'end': '終了',
        'prog_seq_num': '製造順番',
        'start(E)': 'スタート',
        'schedule amount': '計画数(個)',
        'production amount': '実績数',
        'detail page': 'ロット(生産計画番号)詳細画面',
        'auto numbering': '自動採番',
        'entry number': '登録番号',
        'Want to delete ?': '削除しますか？',
        'Want to cancel this produce path ?': 'この製造パスを取り消しますか？',
        'Not Number': '数字ではありません',
        'Not Bitmap': 'ビット(0,1)指定ではありません',
        'Not Integer Number': '整数ではありません',
        'Not Positive Integer': '正の整数ではありません',
        'Please input date and time': '日時を入力してください',
        'required input field': '必須入力です',
        'unexpected error': '想定外のエラーが発生しています',
        'NEW CREATE': '新規作成',
        'EDIT': '編集',
        'DELETE': '削除',
        'CREATE or EDIT': '作成or編集',
        'OK': '確定',
        'CLOSE': '閉じる',
        'OPEN': '開く',
        'work_content': '作業内容',
        'ct_calc_type': 'サイクル計算タイプ',
        'standard_ct': '標準サイクルタイム(秒)',
        'worker_id': '作業者ID(連番)',
        'worker identifier (employee number, , , etc)': 'ID情報(社員番号等)',
        'work_order': '順番(整数)',
        'notified (Modbus address)': '通知先(Modbusアドレス)',
        'The address must be between 1 and 2000': 'アドレスには 1 〜 2000 までの数値を指定してください',
        'work_no': '作業順情報 識別子',
        'mst page': 'マスタ管理画面',
        'progress input page': '進捗入力ツール',
        'mst icon': 'マ',
        'process progress icon': '工',
        'm_factory icon': '工',
        'm_line icon': 'ラ',
        'm_facility icon': '設',
        'm_work_process icon': '手',
        'm_work_content icon': '内',
        'm_work_order icon': '作',
        'm_worker icon': '者',
        'm_product icon': '品',
        'm_report_content icon': '報',
        'm_call_content icon': '呼',
        'i_work_to_facility icon': '付',
        'facility_and_modbus icon': 'M',
        'alarm icon': 'ア',
        'm_alarm_bit icon': 'AB',
        'm_status_bit icon': 'SB',
        'i_report_to_alarm icon': '関',
        'm_production_plan icon': '計',
        'm_facility_status icon': 'ST',
        'm_cycle_time icon': 'サ',
        'm_alarm_mixed_tag icon': '複',
        't_scheduled_stop icon': '停',
        'm_maintenance icon': 'メ',
        'm_iot_alarm icon': 'I',
        'update date': '日付変更',
        'production plan date': '生産日付',
        'production plan entry day': '登録日',
        'not work progress config': 'データは空(登録、製造開始、製造終了の３つは必ずステータスに存在する仕様のため、この表示はない)',
        'locked facility': '設備で他の計画が実行中です',
        'usage Key Board': '(下記ソフトキーボードをタッチして検索してください)',
        'progress heading': '作業状況記録',
        'current actual quantity': '現在の実績数',
        'actual quantity heading': '実績数入力',
        'report heading': '報告事項一覧/入力',
        'call heading': '呼出ボタン/呼出履歴一覧',
        'continue': '続き',
        'm_system_parameter': '系統マスタ',
        'system parameter name': '系統名',
        'sys_prm_id': '系統ID',
        'm_give_x_ration': '分配先マスタ',
        'give_id': '分配先ID',
        'm_give_x_ration_and_line': '分配先-工場-ライン紐付け',
        'm_give_portition': '分配比率マスタ',
        'fixed_number': '固定数値分配',
        'fixed_rate': '固定比率分配',
        'dynamic_rate': '動的比率分配',
        'The sum of fixed rate and dynamic rate should not exceed 1': '固定と動的の比率合計は１を超えないようにしてください',
        'keyw': '分配方法 keyw',
        'rate': '比率',
        'm_portioner_rate': '分配先比率マスタ',
        'total rate': '合計比率',
        'The give_id should not duplicate': '分配先が重複しています',
        'port_rate_id': '分配先比率ID',
        'm_inf_category': 'カテゴリマスタ',
        'category_id': 'カテゴリID',
        'm_co2_emission_factor': 'CO2排出係数マスタ',
        'factor_id': '係数ID',
        'factor': '係数',
        'applied_from': '適用日時',
        'bind info': '紐付け情報',
        'm_portioner_dynamic_rate_logic_type': '動的比率 ロジック指定',
        'logic': 'ロジック',
        'number of cavity': '取り数',
        'factory-line': '工場-ライン',
        'facility shot': '設備取得ショット数',
        'facility production amount': '設備実績数',
        'facility production quantity': '設備取得良品数',
        'facility defective quantity': '設備取得不良品数',
        'm_facility_auto_progress': '製造履歴自動化設定マスタ',
        'm_progress_history_worker_position': 'ポジション 名称 マスタ',
        'm_progress_history_worker_position icon': 'ポ',
        'm_facility_auto_progress icon': '自',
        'mn_tag': '品番タグ連携',
        'on': 'ON',
        'off': 'OFF',
        'actual quantity delete': '入力実績破棄',
        'wr_tag': '作業者タグ連携',
        'm_line_info': 'ライン追加情報マスタ',
        'plan_interval': '生産インターバル(分)',
        'ignore_default': '非稼働デフォルト',
        'm_line_info icon': 'ラ',
        'm_line_product_info': 'ライン品番生産効率マスタ',
        'm_line_product_info icon': '効',
        'standard_input_rate': '標準投入対生産数',
        'm_ignore_time_default': '非稼働時間デフォルト範囲マスタ',
        'm_ignore_time_default icon': '非',
        'length_min': '長さ(分)',
        'line_production_cycle': 'ライン製造サイクル(分)',
        'production setting': '製造関連設定',
        'person register': '担当者登録',
        'person register or remove': '担当者登録・削除',
        'person': '担当者',
        'register': '新規入力',
        'plan quantity': '計画数',
        'production progress input': '生産進捗入力',
        'alert input': '異常停止入力',
        'defective input': '不良品入力',
        'occurrence of defective products input': '不良品入力',
        'defective type': '不良種別',
        'defective details': '不良内容',
        'call': '呼び出し',
        'link to production history list': '生産履歴一覧へ',
        'link to currently in manufacturing': '現在製造中へ',
        'link to facility select page': '設備選択画面へ',
        'link to history input start': '履歴入力開始へ',
        'link to production plan number select': '生産計画番号選択へ',
        'Please input value': '値を入力してください',
        'manufacturing': '製造中',
        'not used': '空き',
        't_progress_history_worker_list input': '担当者入力',
        't_progress_history_worker_list change history': '担当者変更履歴',
        'branch': 'ポジション',
        'clockin': '変更時間',
        'change or edit': '変更・編集',
        'produce path record': '製造パス記録',
        'start and restart': '開始・再開始',
        'interruption': '中断',
        'path history': '動作履歴',
        'path name': 'パス名',
        'modify': '修正',
        'link to plan history list': '生産計画・履歴一覧へ',
        'worker heading': '担当者一覧/入力',
        'planned quantity of plan': '生産計画No.計画数',
        'planned quantity of progress': '当設備計画数',
        'check finish progress': 'この生産計画番号を終了する',
        'production_plan_number': '生産計画番号',
        'product_no': '品番',
        'planned_quantity': '計画数',
        'planned_quantity_of_plan': '生産計画No.計画数',
        'planned_quantity_of_progress': '当設備計画数',
        'current state': '現在の状態',
        'state': '状態',
        'in operation': '稼働中',
        'm_work_shift_name': '直名称マスタ',
        'm_work_shift_name icon': '直名',
        'm_work_shift_calender': '直予定マスタ',
        'm_work_shift_calender icon': '直予',
        'work shift day': '直日付',
        'work shift ID': '直ID',
        'work shift name': '直名',
        'm_scheduled_stop_name': '計画停止マスタ',
        'm_scheduled_stop_name icon': '停名',
        'm_scheduled_stop_calender': '計画停止予定マスタ',
        'm_scheduled_stop_calender icon': '停予',
        'scheduled stop day': '計画停止日付',
        'scheduled stop ID': '計画停止ID',
        'scheduled stop name': '計画停止名',
        'datetime': '日時',
        'model': '型式',
        'indivisual_no': '個体番号',
        'remarks': '項目',
        'value': '値',
        'filter column': '絞り込み列',
        'filter word': '絞り込みキーワード',
        'Search Traceability': 'トレサビ検索画面',
        'search start datetime': '検索 開始日時',
        'search finish datetime': '検索 終了日時',
        'serach': '検索',
        'download CSV': 'CSVダウンロード',
        'max display rows': '最大表示数',
        'loss reason manage': 'ロス理由管理',
        'stop reason ID': '停止理由ID',
        'stop loss': '停止ロス',
        'performance loss': '性能ロス',
        'link to loss reason list': 'ロス理由一覧へ',
        'loss duration': 'ロス秒数',
        'loss reason': 'ロス理由',
        'loss type': 'ロス区分',
        'search column': '検索列',
        'search keyword': '検索キーワード',
        'add': '追加',
        'null to default loss type': '未入力の場合はデフォルトロス区分に従う',
        'display range': '表示範囲',
        'narrow down': '絞り込み',
        'no data': 'データ無し',
        'loss reason exclusive choice': 'alarm_code と stop_reason_id はどちらか一方のみ選択してください',




        'mst setting page': '同期マスタ設定',
        'table name': 'テーブル名',
        'table comment': 'コメント',
        'last exported': '最終同期日時',

        'device status page': 'デバイス状態一覧',
        'core device thing name' : 'デバイス名',
        'last status update timestamp': '最終更新日時',
        'detail': '詳細',
        'select time range': '日時範囲選択',

        'device detail page': 'デバイス状態詳細',
        'device name': 'デバイス名',
        'component name': 'コンポーネント名',
        'component version': 'バージョン',
        'last reported timestamp': '最終報告日時',
        'last status change timestamp': '最終ステータス変更日時',
        'lifecycle state': 'ライフサイクル状態',
        'lifecycle state details': 'ライフサイクル詳細',
        'log download': 'ログDL',

        'process setting page': '加工処理設定',
        'id': 'ID',
        'seq': '優先順',
        'output': '書き込み先',
        'trigger tag': 'トリガータグ名',
        'process type': '処理方法',
        'process params': '処理パラメータ',
        'deployed': 'デプロイ状態',

        'deploy setting page': 'デプロイ設定',
        'deploy target': 'デプロイ先',
        'select device': 'デバイス選択',
        'select device group': 'グループ選択',
        'edge version': 'Edgeバージョン',
        'process setting group': '加工処理グループ',
        'process setting group version': '加工処理グループバージョン',
        'group name': 'グループ名',
        'version number': 'バージョン番号',
        'memo': 'メモ',
        'selected process': '加工処理',
        'select edge version': 'Edgeバージョン選択',
        'select process setting group': '加工処理グループ選択',
        'select process setting group version': '加工処理グループバージョン選択',


        'process setting group page': '加工処理グループ作成',

        'process setting group version page': '加工処理グループ詳細',

        'to': '～',
        'Do you want to confirm?': '確定しますか？',
        'option': '(オプション)',

        'SHOW': '表示',
        'CHECK': '確認',

        'deploy status': 'デプロイ状態',

        'Too Large': '大きすぎます',

        'COMPLETED': '完了',
        'ACTIVE': '実行待ち',
        'FAILED': '失敗',

        'to dereva_dynamodb': 'DynamoDB',
        'to dereva_s3': 'S3',
        'to konektiex': 'KonektiEX',
        'to local_inmemory': 'ローカル保持',
        'to deviceshadow': 'デバイスシャドウ',

        'trigger tag value' : 'トリガータグ値',
        'trigger tag lag': 'トリガータグ遅延(ミリ秒)',
        'to local_inmemory_history': 'ローカル保持(履歴)',
        'history limit': '履歴保持件数',
        'to local_noreset': '保持永続化',
    }
}

export default msg
